<template>
<form @submit.prevent="onsubmit">
  <va-input
    v-model="email"
    type="email"
    :label="$t('auth.email')"
    :error="!!emailErrors.length"
    :error-messages="emailErrors"
  />

  <va-input
    v-model="password"
    type="password"
    :label="$t('auth.password')"
    :error="!!passwordErrors.length"
    :error-messages="passwordErrors"
  />

  <div class="d-flex justify--center mt-3">
    <va-button type="submit" class="my-0">{{ $t('auth.login') }}</va-button>
  </div>
  <div class="auth-layout__options d-flex align--center justify--space-between">
    <router-link class="ml-1 link" :to="{name: 'recover-password'}">{{$t('auth.recover_password')}}</router-link>
  </div>

</form>
</template>

<script>
import hiqapi from '@/hiqapi/hiqapi'

export default {
  name: 'login',
  data() {
    return {
      email: '',
      password: '',
      keepLoggedIn: false,
      emailErrors: [],
      passwordErrors: [],
    }
  },
  computed: {
    formReady() {
      return !this.emailErrors.length && !this.passwordErrors.length
    },
  },
  methods: {
    async onsubmit() {
      this.emailErrors = this.email ? [] : ['Email is required']
      this.passwordErrors = this.password ? [] : ['Password is required']
      if (!this.formReady) {
        return
      }
      let resp = await hiqapi.postPutWait('post', '/sessions', { 'email': this.email, 'password': this.password })
      console.log('BACK resp=', resp)

      if (resp.status !== 201) {
        this.passwordErrors = ['Incorrect email or password']
        return
      }
      this.$cookie.set('qsession', resp.data.session_key)
      this.$cookie.set('qemail', this.email)
      this.$cookie.set('qea', resp.data.is_admin)
      this.$router.push({ name: 'dashboard' })
      this.$mixpanel.identify(this.email)
    },
  },
  mounted() {
    if (this.$route.query.l) {
      this.$cookie.set('qsession', null) // logout if query parm has l=y (or l=<anything>)
      this.$mixpanel.reset()
    }
  },
}
</script>

<style lang="scss">
</style>
